module.exports = __webpack_public_path__ + "static/img/16.a2c8efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/16.jpg
// module id = sA+Q
// module chunks = 0